module.exports = __webpack_public_path__ + "media/images/logo-fortaleza-large_old-b5057982a48deee99334cff05d93a95f.png";